import React from 'react';
import { IMAGES } from '../utils/constants';
import { scrollToOffer } from '../utils/scroll';
export function PackComposite() {
  return <section className="py-16 md:py-24 px-4 bg-white overflow-hidden" data-id="element-200">
      <div className="max-w-5xl mx-auto text-center" data-id="element-201">
        <h2 className="text-3xl md:text-4xl font-extrabold text-blue-900 mb-4" data-id="element-202">
          Un sistema completo pensato per aiutarti a insegnare con più efficacia
        </h2>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-16" data-id="element-203">
          Non un singolo manuale, ma un vero kit professionale per trasformare
          il tuo modo di preparare e vivere ogni lezione di musica.
        </p>

        <div className="relative h-[350px] md:h-[500px] flex items-center justify-center group cursor-pointer" onClick={scrollToOffer} data-id="element-204">
          {/* Orange Glow Background */}
          <div className="absolute inset-0 flex items-center justify-center" data-id="element-205">
            <div className="w-64 h-64 md:w-96 md:h-96 bg-orange-400/20 rounded-full blur-3xl group-hover:bg-orange-400/30 transition-colors duration-500" data-id="element-206"></div>
          </div>

          {/* Fan Images */}
          <img src={IMAGES.TOMO_2} alt="Risorsa 1" className="absolute w-[20%] md:w-[22%] left-[2%] md:left-[10%] top-[18%] md:top-[15%] -rotate-12 group-hover:-translate-x-8 group-hover:-rotate-12 transition-all duration-500 shadow-xl rounded-md" data-id="element-207" />

          <img src={IMAGES.TOMO_3} alt="Risorsa 2" className="absolute w-[22%] md:w-[24%] left-[16%] md:left-[22%] top-[8%] md:top-[10%] -rotate-6 group-hover:-translate-x-4 group-hover:-rotate-6 transition-all duration-500 shadow-xl z-10 rounded-md" data-id="element-208" />

          <img src={IMAGES.TOMO_5} alt="Risorsa 4" className="absolute w-[22%] md:w-[24%] right-[16%] md:right-[22%] top-[8%] md:top-[10%] rotate-6 group-hover:translate-x-4 group-hover:rotate-6 transition-all duration-500 shadow-xl z-10 rounded-md" data-id="element-209" />

          <img src={IMAGES.TOMO_2} alt="Risorsa 5" className="absolute w-[20%] md:w-[22%] right-[2%] md:right-[10%] top-[18%] md:top-[15%] rotate-12 group-hover:translate-x-8 group-hover:rotate-12 transition-all duration-500 shadow-xl rounded-md" data-id="element-210" />

          {/* Main Product */}
          <img src={IMAGES.TOMO_1} alt="Prodotto Principale" className="absolute w-[32%] md:w-[35%] top-[3%] md:top-[5%] z-30 group-hover:scale-110 group-hover:-translate-y-4 transition-all duration-500 shadow-2xl rounded-md" data-id="element-211" />
        </div>
      </div>
    </section>;
}